var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgServiceCredentials = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.72 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.26 14.098a5 5 0 1 1 0-4.195l.06-.003h8.859a.7.7 0 0 1 .495.205l1.4 1.4a.7.7 0 0 1 0 .99l-2.361 2.36a.7.7 0 0 1-.974.016l-1.153-1.08-1.437 1.135a.7.7 0 0 1-.822.033l-1.289-.859H11.32q-.03 0-.06-.002M6.72 15.8a3.8 3.8 0 0 0 3.693-2.9h3.777a.7.7 0 0 1 .388.118l1.112.741 1.49-1.177a.7.7 0 0 1 .913.04l1.113 1.043L20.871 12l-.9-.9h-9.558a3.802 3.802 0 0 0-7.493.9 3.8 3.8 0 0 0 3.8 3.8",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgServiceCredentials);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/service-credentials.7d68dc14.svg";